let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Ck85q")).then(() => parcelRequire('lnuY1'));